import * as React from 'react';
import * as moment from 'moment';
import NavBar from '../../components/NavBar';
import CenteredPageContainer from '../../components/CenteredPageContainer';
import styled from 'styled-components';
import VolumeSelectors from '../../components/FormComponents/VolumeSelectors';
import AddressInputForm from '../../components/FormComponents/AddressInputForm';
import ImageCarousel from '../../components/ImageCarousel';
import PersonDetailRow from './components/PersonDetailRow';
import TotalPricingComponent from '../../components/TotalPricingComponent';
import DatePicker from '../../components/FormComponents/DatePicker';
import { RouteComponentProps } from 'react-router-dom';
import MapView from '../../components/MapView';
import EditedInfo from './components/EditedInfo';
import RectangleButton from '../../components/Buttons/RectangleButton';
import ErrorPage, { MatchErrorPage } from './components/ErrorPage';
import { FullWidthContainer, NoPaddingCol, NoGutterRow } from 'src/components/Grid/FullWidthGrid';
import {
  findMatch_findMatch as MatchListingQuery_findMatch,
  OrderItemsCreateOneInput,
} from 'src/schema';
import { MatchListingQuery, MatchListingQueryGql } from './Queries/MatchListingQuery';
import LoadingPage from './components/LoadingPage';
import { CreateMatchMutationGql, CreateMatchMutation } from './Mutations/CreateMatchMutation';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import Modal from 'reactstrap/lib/Modal';
import ConfirmModal from './components/ConfirmModal';
import * as cuid from 'cuid';
import TermsOfService from './components/TermsOfService';

const BookStorageContainer = styled.div`
  border-top: 1px solid #e0e0e0;

  padding-left: 22px;
  padding-right: 22px;
  padding-top: 24px;
  padding-bottom: 24px;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  box-shadow: -1px 0px 0px #e0e0e0;
`;

const BookStorageButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const LocationDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledModal = styled(Modal)``;

const ProfilePicture = styled.img`
  width: 44px;
  height: 44px;
  border-radius: 22px;
  border: 2px solid #ffffff;
  background-color: black;
  position: absolute;
  left: 44px;
  top: 418px;
  z-index: 100;
`;

interface state {
  customerLat: number;
  customerLong: number;
  startDate: moment.Moment | null;
  endDate: moment.Moment | null;
  address: string;
  standardBoxes: number;
  mediumItems: number;
  largeItems: number;
  extraLargeItems: number;
  enormousItems: number;
  edited: boolean;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  modalOpen: boolean;
  termsOfService: boolean;
}

export interface Item {
  title: string;
  price: string;
  dollarValue: number;
}

class MatchPage extends React.Component<RouteComponentProps<any>, state> {
  state = {
    customerLat: this.props.location.state !== undefined ? this.props.location.state.lat : 0,
    customerLong: this.props.location.state !== undefined ? this.props.location.state.lng : 0,
    startDate: this.props.location.state !== undefined ? this.props.location.state.startDate : null,
    endDate: this.props.location.state !== undefined ? this.props.location.state.endDate : null,
    address: this.props.location.state !== undefined ? this.props.location.state.address : '',
    standardBoxes:
      this.props.location.state !== undefined ? this.props.location.state.standardBoxes : 0,
    mediumItems:
      this.props.location.state !== undefined ? this.props.location.state.mediumItems : 0,
    largeItems: this.props.location.state !== undefined ? this.props.location.state.largeItems : 0,
    extraLargeItems:
      this.props.location.state !== undefined ? this.props.location.state.extraLargeItems : 0,
    enormousItems:
      this.props.location.state !== undefined ? this.props.location.state.enormousItems : 0,
    edited: false,
    email: this.props.location.state !== undefined ? this.props.location.state.email : '',
    firstName: this.props.location.state !== undefined ? this.props.location.state.firstName : '',
    lastName: this.props.location.state !== undefined ? this.props.location.state.lastName : '',
    phoneNumber:
      this.props.location.state !== undefined ? this.props.location.state.phoneNumber : '',
    modalOpen: false,
    termsOfService: false,
  };

  initialValues = {
    customerLat: this.props.location.state !== undefined ? this.props.location.state.lat : 0,
    customerLong: this.props.location.state !== undefined ? this.props.location.state.lng : 0,
    startDate: this.props.location.state !== undefined ? this.props.location.state.startDate : null,
    endDate: this.props.location.state !== undefined ? this.props.location.state.endDate : null,
    address: this.props.location.state !== undefined ? this.props.location.state.address : '',
    standardBoxes:
      this.props.location.state !== undefined ? this.props.location.state.standardBoxes : 0,
    mediumItems:
      this.props.location.state !== undefined ? this.props.location.state.mediumItems : 0,
    largeItems: this.props.location.state !== undefined ? this.props.location.state.largeItems : 0,
    extraLargeItems:
      this.props.location.state !== undefined ? this.props.location.state.extraLargeItems : 0,
    enormousItems:
      this.props.location.state !== undefined ? this.props.location.state.enormousItems : 0,
    edited: false,
    email: this.props.location.state !== undefined ? this.props.location.state.email : '',
    firstName: this.props.location.state !== undefined ? this.props.location.state.firstName : '',
    lastName: this.props.location.state !== undefined ? this.props.location.state.lastName : '',
    phoneNumber:
      this.props.location.state !== undefined ? this.props.location.state.phoneNumber : '',
  };

  finishPayment = (listing: MatchListingQuery_findMatch, items: Item[]) => {
    this.props.history.push({
      pathname: '/post-checkout',
      state: {
        listing,
        items,
        startDate: this.state.startDate,
        endDate: this.state.endDate,
      },
    });
  };

  updateItems = (
    priceStandardBox: number,
    priceMediumItem: number,
    priceLargeItem: number,
    priceExtraLargeItem: number,
    priceEnormousItem: number,
  ) => {
    const items: Item[] = [];
    if (this.state.standardBoxes > 0) {
      items.push({
        title: 'Standard Boxes',
        price: `$${this.state.standardBoxes * priceStandardBox}`,
        dollarValue: this.state.standardBoxes * priceStandardBox,
      });
    }
    if (this.state.mediumItems > 0) {
      items.push({
        title: 'Medium Items',
        price: `$${this.state.mediumItems * priceMediumItem}`,
        dollarValue: this.state.mediumItems * priceMediumItem,
      });
    }

    if (this.state.largeItems > 0) {
      items.push({
        title: 'Large Items',
        price: `$${this.state.largeItems * priceLargeItem}`,
        dollarValue: this.state.largeItems * priceLargeItem,
      });
    }

    if (this.state.extraLargeItems > 0) {
      items.push({
        title: 'Extra Large Items',
        price: `$${this.state.extraLargeItems * priceExtraLargeItem}`,
        dollarValue: this.state.extraLargeItems * priceExtraLargeItem,
      });
    }

    if (this.state.enormousItems > 0) {
      items.push({
        title: 'Enormous Items',
        price: `$${this.state.enormousItems * priceEnormousItem}`,
        dollarValue: this.state.enormousItems * priceEnormousItem,
      });
    }

    items.push({
      title: 'Boxes & Tape',
      price: 'free',
      dollarValue: 0,
    });

    items.push({
      title: 'StoreWith Insurance',
      price: 'free',
      dollarValue: 0,
    });
    return items;
  };

  render() {
    const invalidItems =
      this.state.standardBoxes === 0 &&
      this.state.mediumItems === 0 &&
      this.state.largeItems === 0 &&
      this.state.extraLargeItems === 0 &&
      this.state.enormousItems === 0;
    const invalidBookStorage = this.state.startDate == null || this.state.endDate == null;
    if (this.props.location.state === undefined) {
      return <ErrorPage />;
    }
    return (
      <CreateMatchMutation mutation={CreateMatchMutationGql}>
        {(createMatch, { loading, data }) => (
          <MatchListingQuery
            query={MatchListingQueryGql}
            variables={{
              input: {
                address: this.initialValues.address,
                location: {
                  latitude: this.initialValues.customerLat,
                  longitude: this.initialValues.customerLong,
                },
                endDate: this.initialValues.endDate,
                startDate: this.initialValues.startDate,
                storageVolume: {
                  standardBox: this.initialValues.standardBoxes,
                  mediumItems: this.initialValues.mediumItems,
                  largeItems: this.initialValues.largeItems,
                  extraLargeItems: this.initialValues.extraLargeItems,
                  enormousItems: this.initialValues.enormousItems,
                },
              },
            }}
          >
            {({ loading, error, data, refetch, networkStatus }) => {
              if (loading) return <LoadingPage />;
              if (
                error ||
                typeof data === 'undefined' ||
                data == null ||
                data.findMatch == null ||
                data.findMatch.owner == null
              ) {
                return <MatchErrorPage />;
              }
              if (networkStatus === 4) {
                return <LoadingPage />;
              }

              const listing: MatchListingQuery_findMatch = data.findMatch;
              return (
                <CenteredPageContainer>
                  <NavBar />
                  <FullWidthContainer fluid>
                    <StyledModal
                      isOpen={this.state.modalOpen}
                      size="sm"
                      toggle={() => this.setState({ modalOpen: !this.state.modalOpen })}
                    >
                      <ConfirmModal
                        onConfirm={() => {
                          const items: OrderItemsCreateOneInput = {
                            create: {
                              standardBox: this.state.standardBoxes,
                              mediumItem: this.state.mediumItems,
                              largeItem: this.state.largeItems,
                              extraLargeItem: this.state.extraLargeItems,
                              enormousItem: this.state.enormousItems,
                            },
                          };
                          createMatch({
                            variables: {
                              input: {
                                items,
                                customer: {
                                  create: {
                                    firstName: this.state.firstName,
                                    lastName: this.state.lastName,
                                    email: this.state.email,
                                    phoneNumber: this.state.phoneNumber,
                                    address: this.state.address,
                                  },
                                },
                                listing: {
                                  connect: {
                                    id: listing.id,
                                  },
                                },
                                storageDates: {
                                  create: {
                                    startDate: moment(this.state.startDate).toISOString(),
                                    endDate: moment(this.state.endDate).toISOString(),
                                  },
                                },
                                orderNumber: cuid(),
                              },
                            },
                          });
                          this.finishPayment(
                            listing,
                            this.updateItems(
                              listing.price.standardBox,
                              listing.price.mediumItem,
                              listing.price.largeItem,
                              listing.price.extraLargeItem,
                              listing.price.enormousItem,
                            ),
                          );
                        }}
                        match={data}
                        startDate={moment(this.state.startDate!)}
                        endDate={moment(this.state.endDate)}
                      />
                    </StyledModal>
                    <NoGutterRow>
                      <NoPaddingCol sm={12} lg={8}>
                        <LocationDetailsContainer>
                          <ProfilePicture src={data.findMatch.owner.profilePicture!} alt="oops" />
                          <ImageCarousel
                            items={data.findMatch.listingPictures.map(pictureSrc => ({
                              src: pictureSrc,
                              altText: 'Picture',
                            }))}
                          />
                        </LocationDetailsContainer>

                        <PersonDetailRow
                          firstName={listing.owner.firstName}
                          lastName={listing.owner.lastName}
                          address={listing.address}
                          customerCoordinate={{
                            lat: this.state.customerLat,
                            lon: this.state.customerLong,
                          }}
                          listingCoordinate={{
                            lat: listing.location.latitude,
                            lon: listing.location.longitude,
                          }}
                          freeInsurance={true}
                          helpItems={true}
                          pickupAnytime={true}
                          bioText={listing.owner.bioText}
                        />
                        <MapView
                          zoom={17}
                          center={{
                            lat: listing.location.latitude,
                            lng: listing.location.longitude,
                          }}
                          style={{
                            height: '30vh',
                            paddingBottom: 24,
                            paddingLeft: 45,
                            paddingRight: 45,
                            marginTop: 12,
                          }}
                        />
                      </NoPaddingCol>
                      <NoPaddingCol sm={12} lg={4} style={{ height: 'calc(100vh - 88px)' }}>
                        <BookStorageContainer>
                          <div>
                            <DatePicker
                              style={{ marginBottom: 8 }}
                              startDate={
                                this.state.startDate != null ? moment(this.state.startDate) : null
                              }
                              endDate={
                                this.state.endDate != null ? moment(this.state.endDate) : null
                              }
                              onChange={(startDate, endDate) => {
                                this.setState({
                                  startDate,
                                  endDate,
                                  edited: true,
                                });
                              }}
                            />
                            <AddressInputForm
                              style={{ marginBottom: 8 }}
                              address={this.state.address}
                              onChange={address => this.setState({ address, edited: true })}
                            />
                            <VolumeSelectors
                              standardBoxes={this.state.standardBoxes}
                              mediumItems={this.state.mediumItems}
                              largeItems={this.state.largeItems}
                              extraLargeItems={this.state.extraLargeItems}
                              enormousItems={this.state.enormousItems}
                              onStandardBoxChange={standardBoxes => {
                                this.setState({ standardBoxes, edited: true });
                              }}
                              onMediumChange={mediumItems =>
                                this.setState({ mediumItems, edited: true })
                              }
                              onLargeChange={largeItems =>
                                this.setState({ largeItems, edited: true })
                              }
                              onExtraLargeChange={extraLargeItems =>
                                this.setState({ extraLargeItems, edited: true })
                              }
                              onEmormousChange={enormousItems =>
                                this.setState({ enormousItems, edited: true })
                              }
                              open={
                                this.state.mediumItems !== 0 ||
                                this.state.largeItems !== 0 ||
                                this.state.extraLargeItems !== 0 ||
                                this.state.enormousItems !== 0
                              }
                              style={{ marginBottom: 24 }}
                            />
                            <TotalPricingComponent
                              items={this.updateItems(
                                listing.price.standardBox,
                                listing.price.mediumItem,
                                listing.price.largeItem,
                                listing.price.extraLargeItem,
                                listing.price.enormousItem,
                              )}
                            />
                          </div>
                          <div>
                            {this.state.edited && (
                              <EditedInfo
                                text={
                                  invalidItems
                                    ? 'You need to store at least one item'
                                    : 'We’ve found a new host better suited to accomodate your needs'
                                }
                              />
                            )}
                            {this.state.edited ? (
                              <RectangleButton
                                invalid={invalidItems}
                                style={{ marginTop: 10 }}
                                onClick={() => {
                                  this.setState({ edited: false }, async () => {
                                    const results = await geocodeByAddress(this.state.address);
                                    const { lat, lng } = await getLatLng(results[0]);
                                    refetch({
                                      input: {
                                        address: this.state.address,
                                        location: {
                                          latitude: lat,
                                          longitude: lng,
                                        },
                                        endDate: moment(this.state.endDate).toISOString(),
                                        startDate: moment(this.state.startDate).toISOString(),
                                        storageVolume: {
                                          standardBox: this.state.standardBoxes,
                                          mediumItems: this.state.mediumItems,
                                          largeItems: this.state.largeItems,
                                          extraLargeItems: this.state.extraLargeItems,
                                          enormousItems: this.state.enormousItems,
                                        },
                                      },
                                    });
                                  });
                                }}
                              >
                                {invalidItems ? 'Book Storage' : 'Re-Match'}
                              </RectangleButton>
                            ) : (
                              <BookStorageButtonContainer>
                                <TermsOfService
                                  checked={this.state.termsOfService}
                                  onChange={e =>
                                    this.setState({ termsOfService: e.target.checked })
                                  }
                                />
                                <RectangleButton
                                  style={{ marginTop: '10px' }}
                                  onClick={() => {
                                    if (!invalidBookStorage && this.state.termsOfService) {
                                      this.setState({ modalOpen: true });
                                    }
                                  }}
                                  invalid={invalidBookStorage || !this.state.termsOfService}
                                >
                                  {invalidItems ? 'Re-Match' : 'Book Storage'}
                                </RectangleButton>
                              </BookStorageButtonContainer>
                            )}
                          </div>
                        </BookStorageContainer>
                      </NoPaddingCol>
                    </NoGutterRow>
                  </FullWidthContainer>
                </CenteredPageContainer>
              );
            }}
          </MatchListingQuery>
        )}
      </CreateMatchMutation>
    );
  }
}

export default MatchPage;



// WEBPACK FOOTER //
// ./src/pages/MatchPage/MatchPage.tsx